import { taskAccessOptions } from "@dashboard/api/queryApi";
import { useSelectedCustomer } from "@dashboard/contexts/selectedCustomerContext";
import { useQuery } from "@tanstack/react-query";
import { useJwt } from "common-frontend-components";

export function useTaskAccess() {
    const userId = useJwt((store) => store.userId);
    const { selectedCustomerId } = useSelectedCustomer();

    return useQuery(taskAccessOptions({ userId, customerId: selectedCustomerId }));
}
